const orders_transformer = async function(orders) {
  const o = JSON.parse(JSON.stringify(orders))

  for (const order of Object.values(o)) {
    for (const item of order.items) {
      if (Object.hasOwn(item, 'status')) continue
      if (item.associated_to) item.status = null
      else item.status = 'Pending'
    }
  }

  return o
}

export default orders_transformer
